import { render, staticRenderFns } from "./UnverifiedIncome.vue?vue&type=template&id=0e3030d7"
import script from "./UnverifiedIncome.vue?vue&type=script&lang=js"
export * from "./UnverifiedIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports